import React from 'react'
import { motion } from 'framer-motion'
import { MessageCircle, Star, Heart, Sparkles } from 'lucide-react'

export const CharacterCardWorkshop = ({ character, characterState, onClick, index = 0 }) => {
  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
    if (num >= 1000) return (num / 1000).toFixed(1) + 'k'
    return num.toString()
  }

  const getFavorabilityLevel = (fav) => {
    if (fav < 20) return { text: '陌生', color: 'text-gray-400' }
    if (fav < 50) return { text: '熟悉', color: 'text-blue-400' }
    if (fav < 80) return { text: '友好', color: 'text-green-400' }
    return { text: '亲密', color: 'text-pink-400' }
  }

  const favorability = characterState?.favorability || 0
  const level = getFavorabilityLevel(favorability)
  const totalChatCount = characterState?.totalChatCount || 0

  return (
    <motion.div
      className="world-card"
      onClick={() => onClick(character)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      whileHover={{ 
        scale: 1.05,
        y: -8,
        transition: { duration: 0.3 }
      }}
    >
      {/* 封面图 - 全屏 */}
      <div className="card-cover">
        {character.avatar ? (
          <img src={character.avatar} alt={character.name} />
        ) : (
          <div className="card-cover-placeholder">
            <MessageCircle className="w-12 h-12 text-primary opacity-50" />
          </div>
        )}
        {/* 底部渐变遮罩 */}
        <div className="card-overlay"></div>
      </div>
      
      {/* 卡片内容 - 覆盖在图片底部 */}
      <div className="card-content">
        <h3 className="card-title">{character.name}</h3>
        
        <p className="card-description">
          {character.description && character.description.length > 60
            ? character.description.substring(0, 60) + '...'
            : character.description || '暂无描述'}
        </p>
        
        {/* 标签 */}
        {character.interests && character.interests.length > 0 && (
          <div className="card-tags">
            {character.interests.slice(0, 3).map((tag, idx) => (
              <span key={idx} className="tag">{tag}</span>
            ))}
          </div>
        )}
        
        {/* 指标 */}
        <div className="card-metrics">
          <div className="metric">
            <MessageCircle className="w-4 h-4" />
            <span>{formatNumber(totalChatCount)}</span>
          </div>
          <div className="metric">
            <Heart className="w-4 h-4" />
            <span style={{ color: level.color === 'text-gray-400' ? '#9ca3af' : 
                                 level.color === 'text-blue-400' ? '#60a5fa' :
                                 level.color === 'text-green-400' ? '#4ade80' :
                                 level.color === 'text-pink-400' ? '#f472b6' : '#ffffff' }}>
              {favorability}
            </span>
          </div>
          {character.rating !== undefined && (
            <div className="metric">
              <Star className="w-4 h-4" />
              <span>{(character.rating || 0).toFixed(1)}</span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  )
}

